export default __webpack_public_path__ + "static/media/no-fit.daf540a7.svg";